<ng-content select="campus-icon, [button-icon]"></ng-content>
<campus-icon
  *ngIf="icon"
  [svgIcon]="icon"
  [class.rotate]="iconAnimation === 'rotate' && processing"
></campus-icon>

<campus-tooltip
  *ngIf="plainTooltip"
  [plainTooltip]="plainTooltip"
  [tooltipDelay]="250"
  [anchor]="element"
  class="[ visually-hidden ]"
>
</campus-tooltip>

<dcr-badge *ngIf="badge" [count]="badge" class="[ absolute -top-2xs -right-2xs ]"></dcr-badge>

<dcr-state-layer class="bg-primary" [for]="element" type="circular"></dcr-state-layer>
<dcr-focus-ring [for]="element"></dcr-focus-ring>
